import { Component } from '@angular/core';
import { FORM_DIRECTIVES, ControlGroup, Control, CORE_DIRECTIVES } from '@angular/common';
import { ROUTER_DIRECTIVES } from '@angular/router-deprecated';
import { RequestMethod } from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';

import { InstitutionService, LoadingService } from '../services';
import { InstitutionModel } from '../models';

import { Validators } from '../common/Validators';
import { HeaderFactory } from '../common/HeaderFactory';

import { InstitutionPipe } from './institutionPipe';

@Component({
    selector: 'instlookup',
    template: require('./institution.html'),
    providers: [InstitutionService],
    directives: [FORM_DIRECTIVES, CORE_DIRECTIVES, ROUTER_DIRECTIVES],
})
export class InstitutionComponent {
    institutions: InstitutionModel[];
    filteredIns: InstitutionModel[] = [];
    insList: InstitutionModel[] = [];
    hasOutcomesFilter = true;
    page = 0;
    filterPipe = new InstitutionPipe();
    searchText = '';
    text$ = new Subject();
    search$ub: Subscription;

    constructor(protected svc: InstitutionService, protected loadingService: LoadingService) {
        this.search$ub = this.text$.debounceTime(250).map((input: any) => input.value)
            .do(() => {
                this.reset();
            })
            .subscribe(value => {
                this.searchText = value;
                this.filterIns();
            });

        this.institutions = JSON.parse(sessionStorage.getItem('cl.institutions')) || [];

        if (this.institutions.length === 0) {
            this.loadingService.startLoad();

            this.svc.getList().subscribe(institutions => {
                this.institutions = institutions;
                this.initFilteredIns();
                this.loadingService.stopLoad();
                sessionStorage.setItem('cl.institutions', JSON.stringify(this.institutions));
            });
        } else {
            this.initFilteredIns();
        }
    }

    private reset() {
        this.page = 0;
        this.insList = [];
    }

    private initFilteredIns() {
        this.filteredIns = this.institutions.slice(0);
        this.filterIns();
    }

    ngOnDestroy() {
        this.search$ub.unsubscribe();
    }

    showMore() {
        const limit = 19;
        const start = this.page * limit;
        this.insList = [...this.insList, ...this.filteredIns.slice(start, start + limit)];
        this.page++;
    }

    onCheck() {
        this.reset();
        this.filterIns();
    }

    filterIns() {
        this.filteredIns = this.filterPipe.transform(this.institutions, [this.searchText, this.hasOutcomesFilter]);
        this.showMore();
    }
}


/** WEBPACK FOOTER **
 ** ./app/institution/InstitutionComponent.ts
 **/